import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function BasicSelect({ tone, setTone }) {
  const handleChange = (event) => {
    setTone(event.target.value);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <InputLabel id="demo-select-small-label">Tone</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={tone}
        label="Tone"
        onChange={handleChange}
      >
        <MenuItem value={"normal"}>Normal</MenuItem>
        <MenuItem value={"humor"}>Humor</MenuItem>
        <MenuItem value={"official"}>Official</MenuItem>
      </Select>
    </FormControl>
  );
}
